import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'upgrade-plan',
  children: {
    customBundles: {
      path: 'custom',
    },
    success: {
      path: 'success',
    },
    error: {
      path: 'error',
    },
    checkout: {
      path: 'checkout',
    },
  },
} as const satisfies Location
